export default {
  methods: {
    onlyNumbers (event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return
      if (event.key.length > 1) return
      if (!/^\d$/.test(event.key)) {
        event.preventDefault()
      }
    }
  }
}
